import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { lastValueFrom } from 'rxjs';

import { MentionDocument } from '../../data/models/mention.model';

@Injectable({
  providedIn: 'root'
})
export class CreateMentionService {
  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {}

  _genDefaultHeader() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

  async createMention(
    selectedSectionId: string,
    selectedSectionName: string,
    selectedUserId: string,
    mentionFromUserId: string,
    fromFirstName: string,
    fromLastName: string,
    mentionToUserIdList: string[],
    toFirstNameList: string[],
    toLastNameList: string[],
    dialogId: string,
    index: number,
    mentionedContent: string
  ): Promise<MentionDocument> {
    const mentionPostBody = {
      selectedSectionId: selectedSectionId,
      selectedSectionName: selectedSectionName,
      selectedUserId: selectedUserId,
      mentionFromUserId: mentionFromUserId,
      fromFirstName: fromFirstName,
      fromLastName: fromLastName,
      mentionToUserIdList: mentionToUserIdList,
      toFirstNameList: toFirstNameList,
      toLastNameList: toLastNameList,
      dialogId: dialogId,
      responseIndex: index,
      mentionedContent: mentionedContent
    };
    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    let headers = this._genDefaultHeader();
    headers = headers.set('LoginUserId', loginUserId);

    const url = `${apiConfig.uri}/licence/${sectionId}/mention`;

    var result = await lastValueFrom(
      this.httpClient.post<MentionDocument>(url, mentionPostBody, {
        headers: headers
      })
    );
    return result;
  }
}
